import React from 'react';
import styled from 'styled-components';
import { CircleSpinner } from 'react-spinners-kit';
import { colors, Regular } from './Styles';

type Props = {
  message?: string;
};

export const LoadingScreen = (props: Props) => {
  return (
    <Parent>
      <Child>
        <CircleSpinner color={colors.primary} />
        <Regular>{props.message || 'Loading...'}</Regular>
      </Child>
    </Parent>
  );
};

const Parent = styled.div`
  position: relative;
  height: 100vh;
`;

const Child = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;

  & > :not(:last-child) {
    margin-bottom: 1rem;
  }
`;
